import React, { useEffect } from 'react'

function PaymentDetail() {
  useEffect(()=>{
    document.title = "RollingAdz: Payment Details" || "Default Title";
  },[])
  return (
    <div>
        <div class="container mt-5">
  <div class="row">
    <div class="col-md-5">
        <div className='card p-3'>

     
      <h2>Invoice Details</h2>
      <div class="mt-3">
        <p><strong>Invoice Number:</strong> INV-001</p>
        <p><strong>Invoice Date:</strong> 2023-05-04</p>
        <p><strong>Due Date:</strong> 2023-05-11</p>
      </div>
      <div class="mt-3">
        <p><strong>Customer Name:</strong> John Doe</p>
        <p><strong>Customer Email:</strong> john.doe@example.com</p>
      </div>
      <div class="mt-3">
        <p><strong>Item:</strong> Product A</p>
        <p><strong>Quantity:</strong> 5</p>
        <p><strong>Price:</strong> $100</p>
      </div>
      <div class="mt-3">
        <p><strong>Subtotal:</strong> $500</p>
        <p><strong>Tax:</strong> $50</p>
        <p><strong>Total:</strong> $550</p>
      </div>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}

export default PaymentDetail